import type { FC } from "react"
import { memo } from "react"
import {
	IconCodePullRequestOutline18,
	IconCompassOutline18,
	IconFileContentOutline18,
	IconGearOutline18,
	IconSquaresConnectedOutline18,
} from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"
import { LucideIcon } from "@productlane/ui/src/components/lucide-icon"

import type { AgentItemType } from "./format"

type IconComponent = FC<{ className?: string }>

const TYPE_ICONS: Record<AgentItemType, IconComponent> = {
	CODE: IconCodePullRequestOutline18,
	CONTENT: IconFileContentOutline18,
	CONTRADICTION: IconFileContentOutline18,
	DOCS_SUGGESTION: IconFileContentOutline18,
	GUIDANCE: IconCompassOutline18,
	DATA: IconSquaresConnectedOutline18,
	ACTION: IconSquaresConnectedOutline18,
	SETUP: IconGearOutline18,
}

export const RecommendationTypeIcon = memo(
	({
		type,
		articleIcon,
		className,
	}: {
		type: AgentItemType
		// A docs change shows the icon of the article it edits.
		articleIcon?: string
		className?: string
	}) => {
		const classes = cn("h-4 w-4 flex-none text-secondary", className)
		if (articleIcon)
			return <LucideIcon icon={articleIcon} className={classes} />
		const Icon = TYPE_ICONS[type]
		return <Icon className={classes} />
	},
)
